<template>
    <div class="animated fadeIn">
      <b-row>
        <b-col sm="12">
          <b-card class="custom-outer">
  
            <b-row class="mb-4">              
              <b-col md="12" class="">
                <b-row>
                  <b-col md="4">
                    <b-form-group label="Hub Name:" :label-cols="3">
                        <div id='container' style="width: 230px;">
                            <ejs-multiselect  id='multi_select2'  placeholder="Select Hub Name" v-model="valueWH" :dataSource='optionsWH' :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='fieldWH' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" 
                            ></ejs-multiselect>
                        </div>
                    </b-form-group>
                </b-col>
                  <b-col md="4">
                    <b-form-group label-cols-sm="3" label="From Date:" class="mb-1">
												<v-date-picker :available-dates='{ start: null, end: new Date() }'
													v-model='selectFromDate'>
												</v-date-picker>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group label-cols-sm="3" label="To Date:" class="mb-1">
                      <v-date-picker :available-dates='{ start: null, end: new Date() }'
													v-model='selectToDate'>
												</v-date-picker>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <!-- <b-col md="12" class=""> -->
                  <b-row>
                    <b-col sm="4">
                                <b-form-group label-cols="3" label="Select Transporter : " class="mb-0">
                                    <ejs-multiselect  id='multi_select2'  placeholder="Select Transporter Name" v-model="transporterVehicle" :dataSource='optionsTransporter' :showSelectAll='showtransporterSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='fieldTransporter' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" 
                                    ></ejs-multiselect>
                                </b-form-group>
                            </b-col>

                  <!-- <b-col sm="4">
                                <b-form-group label-cols="3" label="Select Vehicle : " class="mb-0">
                                    <ejs-multiselect  id='multi_select2'  placeholder="Select Vehicle Number" v-model="valueVehicle" :dataSource='optionsVehicle' :showSelectAll='showVehicleSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='fieldVehicle' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" 
                                    ></ejs-multiselect>
                                </b-form-group>
                            </b-col>
                            
 -->
 <b-col md="4"> 
                    <b-form-group  label="Select Vehicle No:" :label-cols="5" class="mb-4">
                        <v-select v-model="valueVehicle" @input="selectsearchvehicle(valueVehicle)" :options="optionsVehicle" placeholder="-- Select Vehicle NO --"></v-select>
                    </b-form-group>
                </b-col>
                  <b-col md="4">
                                <b-form-group label-cols="3" label="Plan Id : " class="mb-0">
                                    <ejs-multiselect  id='multi_select2'  placeholder="Select Plan Id" v-model="valuePlan" :dataSource='optionsPlan' :showSelectAll='showPlanSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='fieldPlan' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" 
                                    ></ejs-multiselect>
                                </b-form-group>
                            </b-col>

                  <b-col md="4">
                  </b-col>
                  <!-- &nbsp; -->
                  </b-row>
                  </b-col>
                  &nbsp;
                  <b-col md="12" class="text-right">
                    <b-button variant="primary" @click="entryGatepassDetails(1)">
                      Search
                    </b-button>
                    &nbsp;
                    <b-button @click="clearSearch()" size="md" variant="danger">Clear</b-button> 
                    &nbsp;
                    <a :href="loadurl" target="_blank" >
                    <b-button @click="downlaodloadurl()" size="md" variant="primary">
                      Download
                    </b-button>
                    </a>
                    &nbsp;
                  <!-- </b-col> -->
              </b-col>
            </b-row>
            <br>
            <b-col sm="12" class="text-right">
            </b-col>
  
            <b-col sm="12">
              <b-table
                show-empty
                responsive
                :busy="isBusy"
                :items="entryGatepassList"
                :fields="fields"
                :current-page="currentPage"
                :bordered="bordered"
                :filter="vehiclefilter"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                @filtered="onFiltered"
              >
                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
                
                
                <template slot="vehicle_no" slot-scope="row">
                  {{ row.item.vehicle_no }}
                </template>
                <template slot="plan_id" slot-scope="row">
                  <button @click.prevent="showPlanDetails(row.item.plan_id)" class="custom-btn">{{ row.item.plan_id }}</button>
                </template>
                <template slot="driver_details" slot-scope="row">
                  <span v-if="row.item.driver_details">{{ JSON.parse(row.item.driver_details)[0].driverNumber }}</span>
</template>

                <template slot="vehicle_type" slot-scope="row">
                  
                  <span v-if="row.item.vehicle_type === 'adhoc'"> 
                    Adhoc
                  </span>
                  <span v-if="row.item.vehicle_type === 'inter' || row.item.vehicle_type === 'intra'"> 
                    Regular
                  </span>
                </template>
                
                <template slot="transporter_name" slot-scope="row">
                  <span> {{ row.item.transporter_name }}</span>
                </template>

                <template slot="drivermobilenumber" slot-scope="row">
                  <span> {{ row.item.drivermobilenumber }}</span>
                </template>
                <template slot="gatepass_in_time" slot-scope="row">
                  <div>
                      {{ row.item.gatepass_in_time | ConvertTime12hour() }}
                  </div>
              </template>

                <template slot="createdat" slot-scope="row">
                  <div>
                      {{ row.item.createdat | ConvertTime12hour() }}
                  </div>
              </template>

              <template slot="hub_name" slot-scope="row">
                <span> {{ row.item.hub_name }}</span>
              </template>

              <!-- <template slot="plan_id" slot-scope="row">
                <span> {{ row.item.plan_id }}</span>
              </template> -->
            
              <template slot="trip_id" slot-scope="row">
                <span> {{ row.item.trip_id }}</span>
              </template>

              <template slot="gate_pass_details" slot-scope="row">
                  <button @click="viewModal(row.item)" class="custom-btn"> <span>  <i class="fa fa-eye" aria-hidden="true"></i> </span></button>
              </template>

              </b-table>
               <!-- pagination -->
               <paginate v-model="pageNum"
                        :page-count="noofpages"
                        :page-range="10"
                        :margin-pages="2"
                        :click-handler="clickCallback"
                        :prev-text="'Prev'"
                        :next-text="'Next'"
                        :container-class="'pagination'"
                        :page-class="'page-item'">
                    </paginate>

            </b-col>
  
          </b-card>
          <b-modal size="lg" v-model="viewPass" @ok="viewPass == false" hide-header>
  <b-row>
    <b-col sm="12">
      <b-form @submit.prevent="editTransporterForm('form-1')" data-vv-scope="form-1">
        <b-row>
          <b-col sm="6">
            <label for="gateno"><strong>Gate No</strong></label>
            <div>{{ updatetransporterObj.gate_name }}</div>
          </b-col>

          <b-col sm="6">
            <label for="Vehicle_number"><strong>Vehicle No</strong></label>
            <div>{{ updatetransporterObj.vehicle_number }}</div>
          </b-col>
        </b-row>

        <b-row class="mt-4">
          <b-col sm="6">
            <label for="route_path"><strong>Route Path (Route No)</strong></label>
            <div>
              <span>{{ updatetransporterObj.route_path }}</span>
            </div>
          </b-col>

          <b-col sm="6">
            <label for="is_market_vehicle"><strong>Is Market Vehicle</strong></label>
            <div>{{ updatetransporterObj.is_market_vehicle }}</div>
          </b-col>
        </b-row>

        <b-row class="mt-4">
          <b-col sm="6">
            <label for="driver_name"><strong>Driver Name</strong></label>
            <span v-if="updatetransporterObj && updatetransporterObj.driver_details">{{  JSON.parse(updatetransporterObj.driver_details)[0].driverName }}</span>
          </b-col>

          <b-col sm="6">
            <label for="driver_mobile"><strong>Driver Mobile</strong></label>
            <span v-if="updatetransporterObj && updatetransporterObj.driver_details">{{  JSON.parse(updatetransporterObj.driver_details)[0].driverNumber }}</span>
          </b-col>
        </b-row>

        <b-row class="mt-4">
          <b-col sm="6">
            <label for="sealVehicle"><strong>Is seal or not</strong></label>
            <div>{{ updatetransporterObj.is_seal_or_not !== null ? updatetransporterObj.is_seal_or_not : NA }}</div>
          </b-col>
          <b-col sm="6">
            <label for="totalsealno"><strong>Total Number of seals</strong></label>
            <div>{{ updatetransporterObj.total_number_of_seal ? updatetransporterObj.total_number_of_seal : NA }}</div>
          </b-col>

          </b-row>

          <b-row class="mt-4" v-if="updatetransporterObj && updatetransporterObj.seal_details">
  <b-col sm="6" v-for="seal in JSON.parse(updatetransporterObj.seal_details)" :key="seal.id">
    <label for="sealphoto"><strong>Seal Photo</strong></label>
    <div>
      <img :src="seal.seal_photo" alt="images" width="70%" height="200px">
    </div>
  </b-col>

  <b-col sm="6" v-for="seal in JSON.parse(updatetransporterObj.seal_details)" :key="seal.id">
    <label for="sealnumber"><strong>Seal Number</strong></label>
    <div>{{ seal.seal_number }}</div>
  </b-col>
</b-row>


       <b-row class="mt-4">
          
         
          
          <b-col sm="6">
            <label for="sealVehicle"><strong>Is seal Verified</strong></label>
            <div>{{ updatetransporterObj.is_seal_verified }}</div>
          </b-col>
          <b-col sm="6">
            <label for="platenumber"><strong>Vehicle/Plate number photo</strong></label>
            <div>
              <img :src="updatetransporterObj.vehicle_imgurl" alt="images" width="70%" height="200px">
            </div>
          </b-col>
         
        </b-row>


        

        <b-row class="mt-4">
         
          <b-col sm="6">
            <label for="adharnumberphoto"><strong>Aadhar Photo</strong></label>
            <div>
              <img :src="updatetransporterObj.driver_adhar_photo" alt="images" width="70%" height="200px">
            </div>
          </b-col>
          <b-col sm="6">
            <label for="licencesphoto"><strong>License Photo</strong></label>
            <div>
              <img :src="updatetransporterObj.driver_license_photo" alt="images" width="70%" height="200px">
            </div>
          </b-col>
          
          
        </b-row>
        

        

        
      </b-form>
    </b-col>
  </b-row>

  <!-- Modal Footer with a Cancel button -->
  <template #modal-footer>
    <b-button variant="secondary" @click="viewPass = false">Cancel</b-button>
    <!-- <b-button variant="primary" @click="editTransporterForm('form-1')">Submit</b-button> -->
  </template>
</b-modal>
        </b-col>
      </b-row>


      <!-- view plan modal start here -->
      <b-modal ref="DD-modal" size="xl" hide-footer title="View Plan Details">
										


										<!-- <div class="d-block float-right">
											<b>Total Records: </b> <b class="text-danger"> {{totalrecords}}</b>
										</div> -->
										<div class="clearfix"></div>
										<b-card-body class="p-0" style="overflow: auto;">
											<div class="table-responsive">
												<b-table class="mt-3" show-empty stacked="md" :busy="isBusy" :items="ddplandetaildata"
													:fields="ddplandetailfields" :current-page="currentPage" :per-page="perPage" :filter="filter"
													:sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
													@filtered="onFiltered" :bordered="bordered" :tbody-tr-class="rowClass">

													<div slot="table-busy" class="text-center text-danger my-2">
														<b-spinner class="align-middle"></b-spinner>
														<strong>Loading...</strong>
													</div>
													<template slot-scope="row">
														<span>{{ row.item.isactive == 1 ? 'active' : 'inactive' }}</span>
													</template>

													<template slot="planningorigin" slot-scope="row">
														<span>{{row.item.planningorigin || 'NA'}}</span>
													</template>

													<template slot="planningdate" slot-scope="row">
														<span>{{row.item.planningdate || 'NA'}}</span>
													</template>

													<template slot="loadid" slot-scope="row">
														<span>{{row.item.loadid || 'NA'}}</span>
													</template>

													<template slot="plandate" slot-scope="row">
														<span>{{row.item.planningdate || 'NA'}}</span>
													</template>

													<template slot="whorhub" slot-scope="row">
														<span>{{row.item.whorhub || 'NA'}}</span>
													</template>

													<template slot="noofboxes" slot-scope="row">
														<span>{{row.item.noofboxes || 'NA'}}</span>
													</template>

													<template slot="shippingreferenceno" slot-scope="row">
														<span>{{row.item.shippingreferenceno || 'NA'}}</span>
													</template>

													<template slot="userid" slot-scope="row">
														<span>{{row.item.userid || 'NA'}}</span>
													</template>

													<template slot="companyname" slot-scope="row">
														<span>{{row.item.companyname || 'NA'}}</span>
													</template>

													<template slot="dest_city" slot-scope="row">
														<span>{{row.item.dest_city || 'NA'}}</span>
													</template>

													<template slot="warehouseorhubname" slot-scope="row">
														<span>{{row.item.warehouseorhubname || 'NA'}}</span>
													</template>

													<template slot="loadpotype" slot-scope="row">
														<span>{{row.item.loadpotype || 'NA'}}</span>
													</template>

													<template slot="shipmentvolumetricweight" slot-scope="row">
														<span>{{row.item.shipmentvolumetricweight || 'NA'}}</span>
													</template>

													<template slot="shippincode" slot-scope="row">
														<span>{{row.item.shippincode || 'NA'}}</span>
													</template>
													<template slot="unloadingsequence" slot-scope="row">
														<span>{{row.item.unloadingsequence || 'NA'}}</span>
													</template>

													<template slot="vehicleno" slot-scope="row">
														<span>{{row.item.vehicleno || 'NA'}}</span>
													</template>
													<template slot="transportername" slot-scope="row">
														<span>{{row.item.transportername || 'NA'}}</span>
													</template>
													<template slot="isregularadhoc" slot-scope="row">
														<span>{{row.item.isregularadhoc || 'NA'}}</span>
													</template>
													<template slot="trip" slot-scope="row">
														<span>{{row.item.trip || 'NA'}}</span>
													</template>
													<template slot="remark" slot-scope="row">
														<span>{{row.item.remark || 'NA'}}</span>
													</template>
												</b-table>

											</div>
										</b-card-body>

										<!-- <b-button class="mt-3" variant="outline-danger" block @click="hideModal">Close Me</b-button>
										<b-button class="mt-2" variant="outline-warning" block @click="toggleModal">Toggle Me</b-button> -->
									</b-modal>
                  <!-- view plan modal end here -->
    </div>

   
  </template>

  <script>
    import CONSTANTS from "@/utils/constants";

    export default {

      data: function(){
        return {
          fields: [
            { key: "vehicle_number", label: "Vehicle Number"},
            { key: "vehicle_type", label: "Vehicle Type" },
            { key: "transporter_company_name", label: "Transporter Name" },
            {
              key: "driver_details",
              label: "Driver Number"
            },
            { key: "gatepass_in_time", label: "In Time" },
            { key: "hub_title", label: "HUB Name" },
            {
              key: "plan_id",
              label: "Plan ID"
            },
            {
              key: "tripid",
              label: "Trip ID"
            },
            {
              key: "createdat",
              label: "Created At"
            },
            { key: "gate_pass_details", label: "Gate Pass Details" },
          ],
          optionsWH: [],
          selected_warehouse: '',
          selectDateFrom: '',
          selectDateTo: '',
          vehicleitems: [],
          selected_transporter: '',
          selected_vehicleno: '',
          selected_planid: '',
          planidList: [],
          transporterList: [],
          viewPass: false,
          gateno: [],
          routeitems: [],
          totalsealnoitems: [],
          sealFileName: '',
          platenumberFilename: '',
          adharnumberphotoFilename: '',
          licencesphotoFilename: '',
          sealFileType: '',
          selectedSealFile: '',
          sealFileName: '',
          sealNumberImage: '',
          selectedVehicleFile: '',
          vehicleFileName: '',
          vehicleFileType: '',
          vehicleNumberImage: '',
          selectedAdharFile: '',
          adharFileType:'',
          adharFileName: '',
          adharNumberImage: '',
          licenseFileName: '',
          licenseFileType: '',
          licenseNumberImage: '',
          // items: [{'vehicle_no': '1233','vehicle_type': 'cng','transportername': 'abc','drivermobilenumber':'9977556677','createddate':'12/12/2024','hub_name':'pune','plan_id':'1233','trip_id':'65565'}]

          entryGatepassList: [],
          valueWH:[],
          fieldWH:{ text: 'name', value: 'id' },
          showSelectAll : true,
          optionsVehicle:[],
          VehicleData:[],
          valueVehicle: [],
          showVehicleSelectAll : true,
          fieldVehicle:{ text: 'name', value: 'id' },
          selectFromDate : new Date(),
          selectToDate:  new Date(),
          transporterData: [],
          optionsTransporter: [],
          transporterVehicle: [],
          showtransporterSelectAll: true,
          fieldTransporter:{ text: 'name', value: 'id' },

          planVehicle: [],
          optionsPlan:[],
          showPlanSelectAll: false,
          PlanData: [],
          valuePlan: [],
          fieldPlan:{ text: 'name', value: 'id' },
          updatetransporterObj: {},
          loadurl :'',
          // 1st pagination
          noofpages:'',
          pageNum:1,
          viewPlanModal: false,
          totalloadtime: '',
          totalrecords: '',
				  ddplandetaildata: [],
          ddplandetailfields: [{
					key: "planningorigin",
					label: "Planning Origin",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "planningdate",
					label: "Planning Date",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "loadid",
					label: "Load ID",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "whorhub",
					label: "WH/HUB",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "noofboxes",
					label: "No. Of Boxes",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "shippingreferenceno",
					label: "Shipping Ref. No.",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "userid",
					label: "User ID",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "companyname",
					label: "Company Name",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "dest_city",
					label: "Dest_City",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "warehouseorhubname",
					label: "warehousename / Hub zone",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "loadpotype",
					label: "loadpotype",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "shipmentvolumetricweight",
					label: "shipmentvolumetric weight",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "shippincode",
					label: "shippincode",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "unloadingsequence",
					label: "unloading sequence",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "vehicleno",
					label: "vehicle no",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "transportername",
					label: "transporter name",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "isregularadhoc",
					label: "Is Regular/Adhoc",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "trip",
					label: "trip",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "remark",
					label: "remark",
					sortable: true,
					sortDirection: "desc",
				}
				],
        }
      },
      created: function(){
        // this.displaydata()
        // this.showPlanidlist()
        // this.showTransporterlist()
        
        this.showWHlist()
        this.displaydata()
        this.transpporterList();
        this.planDataListing();
        this.entryGatepassDetails(1);
        
      },
      watch: {
          // Watch for changes in optionsWH to handle the case when it changes dynamically
          optionsWH(newOptions) {
              if (newOptions.length === 1) {
                  // If there's only one option, set it as the default selected value
                  this.valueWH = [newOptions[0].id];  // Assuming each option has an 'id' field
              }
          }
      },
      mounted() {
          if (this.optionsWH.length === 1) {
              // If there's only one option, set it as the default selected value
              this.valueWH = [this.optionsWH[0].id];  // Assuming each option has an 'id' field
          }
      },
      methods: {
        clearSearch() {
          
          this.valueWH = [];
          this.transporterVehicle = [];
          this.valueVehicle = [];
          this.valuePlan = [];
          this.selectFromDate = new Date();
          this.selectToDate = new Date();
          this.entryGatepassDetails(1);
          
          // this.selected_warehouse = ''
          // this.selectDateFrom = ''
          // this.selectDateTo = ''
          // this.selected_transporter = '',
          // this.selected_vehicleno = ''
          // this.selected_planid = ''planid
          // this.showWHlist()
          // this.displaydata()
          // this.showPlanidlist()
			  },
        displaydata: function() {

          var userdata = localStorage.getItem("userData");
          var userInfo = JSON.parse(userdata);

          this.vehicleitems=[];
          const deliveryagentobj = {
              sysusermasterid: `${userInfo.sysusermasterid}`,
              usertype: `${userInfo.user_type}`,
              isactive: "1",
              vehicle_type: "bulkreallocate",
          };
          // return false;
          this.$http
          .post(
          `${CONSTANTS.MIGRATION_API_URL}/getVehicleListing`,
          deliveryagentobj
          )
          .then((result) => {
          if (result.body.length > 0) {
              this.data = result.body;
              this.vehicleitems = result.body;
              var data = [];

              result.body.forEach(function (srData) {
                  data.push({
                  key:srData.vehicle_id,
                  label:srData.vehicle_no
                  });
              });
              this.vehicleitems = data;
          } else {
              this.data = result.body;
              this.vehicleitems = result.body;
          }
          })
          .catch((ex) => {
          console.log("error", ex);
          });
        },
        showPlanidlist: function () {
          var userdata = localStorage.getItem('userData')
          var userInfo = JSON.parse(userdata)

          const obj = {
            sysusermasterid: `${userInfo.sysusermasterid}`,
            usertype: `${userInfo.user_type}`,
          }

          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllPlanidListing`, obj)
            .then(result => {
              if (result.body.returnmsg === 'Successful') {
                this.planidList = result.body.returnvalue;
              } else {
                this.planidList = []
              }

            })
            .catch(ex => {
              console.log("error-----", ex);
            });
        },
        showTransporterlist: function () {
          var userdata = localStorage.getItem('userData')
          var userInfo = JSON.parse(userdata)

          const obj = {
            sysusermasterid: `${userInfo.sysusermasterid}`,
            usertype: `${userInfo.user_type}`,
          }

          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllTransporterListing`, obj)
            .then(result => {
              if (result.body.returnmsg === 'Successful') {
                this.transporterList = result.body.returnvalue;
              } else {
                this.transporterList = []
              }

            })
            .catch(ex => {
              console.log("error-----", ex);
            });
        },
        viewModal: function(data){
          this.viewPass = true;
          console.log(data, 'datattttt');
          this.updatetransporterObj = data
          this.updatetransporterObj.driverName = this.updatetransporterObj.driver_details[0].driverName
          this.updatetransporterObj.driverNumber = this.updatetransporterObj.driver_details[0].driverNumber
        },
        selectSealNumberFile(event){
            this.selectedSealFile= event.target.files[0];            
            if (this.selectedSealFile) {
                this.sealFileName = `${event.target.files[0].name}`; 
            }
            this.sealFileType = this.selectedSealFile.type;
            this.uploadSealNumberFile(this.selectedSealFile);
        },

        uploadSealNumberFile : function () {
         var userData = localStorage.getItem('userData');
         var userInfo = JSON.parse(userData);

            let data = new FormData();
            data.append('file', this.selectedSealFile)
            axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`,data, 
                {
                    header : { 'Content-Type' : 'multipart/form-data'
                    }, 
                })
            .then(response => {
                if (response.data.result=='success') {
                    this.$fire({
                        text:"File Uploaded",
                        type: "success",
                        timer: 300000
                    })
                    this.sealNumberImage=response.data.image_url;                    
                } else {
                    this.$fire({
                        text:"File Not Uploaded",
                        type: "error",
                        timer: 300000
                    })
                }
            })
            .catch(e => {
                console.log('Error In Upload Bank check',e);
                
            })
        
        },
        selectAdharNumberFile(event){
            this.selectedAdharFile= event.target.files[0];            
            if (this.selectedAdharFile) {
                this.adharFileName = `${event.target.files[0].name}`; 
            }
            this.adharFileType = this.selectedAdharFile.type;
            this.uploadAdharNumberFile(this.selectedAdharFile);
        },

        uploadAdharNumberFile : function () {
         var userData = localStorage.getItem('userData');
         var userInfo = JSON.parse(userData);

            let data = new FormData();
            data.append('file', this.selectedAdharFile)
            axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`,data, 
                {
                    header : { 'Content-Type' : 'multipart/form-data'
                    }, 
                })
            .then(response => {
                if (response.data.result=='success') {
                    this.$fire({
                        text:"File Uploaded",
                        type: "success",
                        timer: 300000
                    })
                    this.adharNumberImage=response.data.image_url;                    
                } else {
                    this.$fire({
                        text:"File Not Uploaded",
                        type: "error",
                        timer: 300000
                    })
                }
            })
            .catch(e => {
                console.log('Error In Upload Bank check',e);
                
            })
        
        },
        selectVehicleNumberFile(event){
            this.selectedVehicleFile= event.target.files[0];            
            if (this.selectedVehicleFile) {
                this.vehicleFileName = `${event.target.files[0].name}`; 
            }
            this.vehicleFileType = this.selectedVehicleFile.type;
            this.uploadVehicleNumberFile(this.selectedVehicleFile);
        },

        uploadVehicleNumberFile : function () {
         var userData = localStorage.getItem('userData');
         var userInfo = JSON.parse(userData);

            let data = new FormData();
            data.append('file', this.selectedVehicleFile)
            axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`,data, 
                {
                    header : { 'Content-Type' : 'multipart/form-data'
                    }, 
                })
            .then(response => {
                if (response.data.result=='success') {
                    this.$fire({
                        text:"File Uploaded",
                        type: "success",
                        timer: 300000
                    })
                    this.vehicleNumberImage=response.data.image_url;                    
                } else {
                    this.$fire({
                        text:"File Not Uploaded",
                        type: "error",
                        timer: 300000
                    })
                }
            })
            .catch(e => {
                console.log('Error In Upload Bank check',e);
                
            })
        
        },
        
        selectedLicenseFile(event){
            this.selectedLicensePhotoFile= event.target.files[0];            
            if (this.selectedLicensePhotoFile) {
                this.licenseFileName = `${event.target.files[0].name}`; 
            }
            this.licenseFileType = this.selectedLicensePhotoFile.type;
            this.uploadVehicleNumberFile(this.selectedLicensePhotoFile);
        },

        uploadVehicleNumberFile : function () {
         var userData = localStorage.getItem('userData');
         var userInfo = JSON.parse(userData);

            let data = new FormData();
            data.append('file', this.selectedLicensePhotoFile)
            axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`,data, 
                {
                    header : { 'Content-Type' : 'multipart/form-data'
                    }, 
                })
            .then(response => {
                if (response.data.result=='success') {
                    this.$fire({
                        text:"File Uploaded",
                        type: "success",
                        timer: 300000
                    })
                    this.licenseNumberImage=response.data.image_url;                    
                } else {
                    this.$fire({
                        text:"File Not Uploaded",
                        type: "error",
                        timer: 300000
                    })
                }
            })
            .catch(e => {
                console.log('Error In Upload Bank check',e);
                
            })
        
        },


      displaydata: function() {

var userdata = localStorage.getItem("userData");
var userInfo = JSON.parse(userdata);

this.vehicleitems=[];
const deliveryagentobj = {
    sysusermasterid: `${userInfo.sysusermasterid}`,
    usertype: `${userInfo.user_type}`,
    isactive: "1",
    vehicle_type: "bulkreallocate",
};
// return false;
this.$http
.post(
`${CONSTANTS.MIGRATION_API_URL}/getVehicleListing`,
deliveryagentobj
)
.then((result) => {
if (result.body.length > 0) {
    this.data = result.body;
    this.optionsVehicle = result.body;
    var data = [];

    result.body.forEach(function (srData) {
        data.push({
        key:srData.vehicle_id,
        label:srData.vehicle_no
        });
    });
    this.optionsVehicle = data;
} else {
    this.data = result.body;
    this.optionsVehicle = result.body;
}
})
.catch((ex) => {
console.log("error", ex);
});
},

selectsearchvehicle(value_vehicle) {
            if(value_vehicle==null){
            this.valueVehicle=[];
            this.entryGatepassDetails(1);
            }
        },

    transpporterList: function() {
 
      var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        this.vehicleitems=[];

        const deliveryagentobj = {
            sysusermasterid: `${userInfo.sysusermasterid}`,
            usertype: `${userInfo.user_type}`,
        };
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/transpporterList`,deliveryagentobj
        )
        .then(result => {
        if (result.body.returnmsg === "Successful") {
            this.optionsTransporter=[];
          
         // this.transporterData  = result.body.returnvalue;
          let resultData = []
          for(let i=0;i<result.body.returnvalue.length;i++) {

            if (resultData.length > 0) {
              const duplicatvehicleid = resultData.find(item => item.transporter_id === result.body.returnvalue[i].transporter_id)
              if (duplicatvehicleid) {
                continue;
              }
            }
            let obj = {
              transporter_company_name : result.body.returnvalue[i].transporter_company_name,
              transporter_id : result.body.returnvalue[i].transporter_id
            }
            resultData.push(obj)
          }

          this.transporterData  = resultData;

          for(let j = 0; j < this.transporterData.length; j++) {
              let WH = {
              name: this.transporterData[j].transporter_company_name + " - " + this.transporterData[j].transporter_id,
              id: this.transporterData[j].transporter_id,
              }
          this.optionsTransporter.push(WH);
          }
            }else{
                this.transporterData  = result.body.returnvalue;
            }
        })
        .catch(ex => {
        console.log("error", ex);
        });
    
    },

    planDataListing: function() {
        
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        this.vehicleitems=[];
        const deliveryagentobj = {};
        this.$http.get(`${CONSTANTS.MIGRATION_API_URL}/planDataListing`)
        .then(result => {
        if (result.body.returnmsg === "Successful") {
            this.optionsPlan=[];
          
          this.PlanData  = result.body.returnvalue;
          
          for(let j = 0; j < this.PlanData.length; j++) {
              let WH = {
              // name: this.PlanData[j].plan_id + " - " + this.PlanData[j].plan_id,
              name: this.PlanData[j].plan_id,
              id: this.PlanData[j].plan_id,
              }
          this.optionsPlan.push(WH);
          }
            }else{
                this.PlanData  = result.body.returnvalue;
            }
        })
        .catch(ex => {
        console.log("error", ex);
        });
    
    },

    formatDate: function(date) {
            var d = new Date(date),
                month = "" + (d.getMonth() + 1),
                day = "" + d.getDate(),
                year = d.getFullYear();
            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;
            return [year, month, day].join("-")
        },

        // ajay code start here
        showWHlist:async function(){
          
          var userdata = localStorage.getItem('userData')
          var userInfo = JSON.parse(userdata)
          
          var csvObj = {
              sysusermasterid:`${userInfo.sysusermasterid}`,
              usertype:`${userInfo.user_type}`
          };
          await this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllHubListing`, csvObj)
              .then(result => {
              
              if (result.body.returnmsg === 'Successful') {
                console.log('3333333333333333333333333');
                  this.optionsWH=[];
              
                  this.WHData  = result.body.returnvalue;
                  
                  
                  for(let j = 0; j < this.WHData.length; j++) {
                      let WH = {
                      name: this.WHData[j].hubname + " - " + this.WHData[j].hubid,
                      id: this.WHData[j].hubid,
                      }
                  this.optionsWH.push(WH);
                  }
              
              } else {              
                  this.WHData  = result.body.returnvalue;
              }
          

          })
          .catch(ex => {
              console.log("error-----", ex);
          });
      },

        entryGatepassDetails: async function (pageNum) {
          console.log('a1111111111')
          await this.showWHlist()
          console.log('a111111111122222222222')
          console.log(this.valueWH, 'this.valueWHthis.valueWH2123123');
          var userdata = localStorage.getItem('userData')
          var userInfo = JSON.parse(userdata)

          var fromdate = (this.selectFromDate!=null)?this.formatDate(this.selectFromDate):null;
          var formatdateto=(this.selectToDate!=null)? this.formatDate(this.selectToDate):null;
          this.isBusy = true; 
          if((fromdate &&  !formatdateto) || (!fromdate &&  formatdateto)){  
              this.$fire({
                      text:"Please Select Proper Date",
                      type: "warning",
                      timer: 30000
                    }); 
                    this.loader=false;
                    this.isBusy = false; 
                    return false;       
          }

          if(formatdateto< fromdate){  
              this.$fire({
                      text:"To date need to be greater than From date",
                      type: "warning",
                      timer: 30000
                    }); 
                    this.loader=false;
                    this.isBusy = false; 
                    return false;       
            }

          console.log(userInfo, 'userInfouserInfo');  
          console.log(this.WHData, 'this.valueWHthis.valueWH222')


          const obj = {
            sysusermasterid: `${userInfo.sysusermasterid}`,
            usertype: `${userInfo.user_type}`,
            entry_status: 'IN',
            hubid: this.valueWH && this.valueWH.length === 0 ? [] : this.valueWH,
            transporter_name: this.transporterVehicle && this.transporterVehicle.length === 0 ? null : this.transporterVehicle,
            vehicleid: this.valueVehicle && this.valueVehicle.length === 0 ? null : [this.valueVehicle.key],
            from: fromdate,
            planid: this.valuePlan && this.valuePlan.length === 0 ? null : this.valuePlan,
            to: formatdateto,
            page_no:pageNum,
          }

          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/gatepassDetailsList`, obj)
            .then(result => {
              this.isBusy = false; 
              if (result.body.returnmsg === 'Successful') {
                this.entryGatepassList = result.body.returnResult;
                this.noofpages=parseInt(this.entryGatepassList[0].totalcount)/10;
                this.noofpages=Math.ceil( this.noofpages);
              } else {
                this.noofpages='',
                this.entryGatepassList.length = 0,
                this.entryGatepassList = []
              }

            })
            .catch(ex => {
              console.log("error-----", ex);
            });
        },

        downlaodloadurl(){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            var selectDate = (this.selectDate!=null)?this.formatDate(this.selectDate):"";

           this.loadurl=`${CONSTANTS.MIGRATION_API_URL}/downloadEntryGatepassDetailsCSV`
        },

        clickCallback (pageNum){
            this.entryGatepassDetails(pageNum);
        },


        showPlanDetails(planid) {
				let sendObj = {
					planid: planid
				}

				this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getPlanDetails`, sendObj).then((result) => {
					if (result && result.body.returnmsg == "Successful" && result.body.returnvalue.plandata.length) {
						this.ddplandetaildata = result.body.returnvalue.plandata
						console.log("dd plan detail data", result)
						this.viewPlanModal = true;
            this.$refs['DD-modal'].show()
					}
				}).catch((ex) => {
					console.log("error", ex);
				});
			},
      }
    }

  </script>
<style scoped>
.custom-btn {
  border: none !important;
}
.custom-outer {
  margin-top: 10px !important;
}
</style>